import { useReveal } from "@/hooks/useReveal";
import SpecTable, { type SpecRow } from "./SpecTable";

const ROWS: SpecRow[] = [
  { label: "Realistic export commitment", value: "One to two 40 ft containers per quarter" },
  { label: "Minimum order", value: "10 tonnes as a minimum" },
  { label: "Default Incoterm", value: "FOB Cartagena or Buenaventura, Colombia" },
  { label: "Alternative Incoterm", value: "CIF Cape Town or Durban, quoted on request" },
  { label: "Payment terms, first order", value: "Irrevocable confirmed letter of credit, or substantial advance payment" },
  { label: "Sourcing", value: "Smallholder farmer cooperatives in Quindío, under certified organic practice" },
];

export default function Supply() {
  const headRef = useReveal<HTMLDivElement>();
  const bodyRef = useReveal<HTMLDivElement>();

  return (
    <section id="supply" className="bg-ink py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={headRef} className="reveal max-w-[800px]">
          <h2 className="text-cream font-serif text-3xl md:text-4xl font-semibold">
            Capacity, and what we will not promise
          </h2>
          <p className="mt-4 text-cream/75 text-lg leading-relaxed">
            Continuity matters more to you than price, and the honest way to
            protect it is to be clear about our ceiling before you homologate us
            rather than after. We are a small plant. That is an advantage for
            tight specification control and a limitation on volume, and we would
            rather decline an enquiry than fail an export customer mid-year.
          </p>
        </div>

        <div
          ref={bodyRef}
          className="reveal mt-12 grid grid-cols-1 lg:grid-cols-[360px_1fr] gap-10"
        >
          <div className="hidden lg:block">
            <img
              src="https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/d0cfe1a1-d9dc-4be2-ad5c-838ac894b7ac_compressed_capacity.webp"
              alt="Kraft paper sacks and a bulk bag on a pallet in a clean ingredient warehouse"
              className="w-full h-[520px] object-cover object-top rounded-lg"
            />
          </div>
          <div>
            <SpecTable dark rows={ROWS} />
          </div>
        </div>

        <div className="mt-10 max-w-[800px] border border-cream/20 rounded-lg px-5 py-4">
          <p className="text-cream/80 text-base leading-relaxed">
            If your annual requirement exceeds what is stated here, tell us in
            the form anyway. We will say so directly rather than quote and then
            ration.
          </p>
        </div>
      </div>
    </section>
  );
}